import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import TaLienSon from './image/booking/Talienson.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 6 ",
    activities: [
      { time: "6:30 PM", description: "Khởi hành từ Hà Nội, điểm đến là TP Lai Châu" },
      { time: "12:00 AM", description: "Có mặt ở homestay tại TP Lai Châu" },
      { description: `Tận hưởng giấc ngủ trọn vẹn tại nơi bao quanh là núi rừng với độ cao gần 1000m, 
        để cơ thể tái tạo năng lượng và tinh thần hoàn toàn tỉnh táo. Một đêm chuẩn bị hoàn hảo sẽ mở ra một
         hành trình chinh phục tuyệt vời nhất!`}
    ],
  },
  {
    day: "Thứ 7 - Ngày Leo",
    activities: [
      { time: "6:00 AM", description: "Bữa sáng ấm áp tại Homestay – Nạp năng lượng cho hành trình mới" },
      { description: `Một buổi sáng ở vùng cao sẽ bắt đầu bằng hương thơm của xôi nếp nương và tách trà nóng. 
        Đừng quên nạp đủ tinh bột và đạm từ thịt, trứng để giữ cho nhịp tim ổn định và đôi chân thêm vững chãi.
         Trước khi đi, hãy để lại những muộn phiền (và cả hành lý thừa) tại homestay, 
         chỉ mang theo một tâm hồn tự do và những vật dụng thiết yếu nhất để sẵn sàng chạm vào mây trời`},
      { time: "6:30 AM", description: "Cung đường xuyên sương sớm – Chuyến xe của tự do" },
      { description: `Porter sẽ đón bạn trên những chiếc 'chiến mã' đặc trưng của vùng núi. 
        Đây là lúc bạn được thả mình giữa những cung đường uốn lượn, băng qua bản làng đơn sơ ẩn hiện 
        trong sương mờ. Gió Tây Bắc sẽ khẽ chạm vào má, mang theo hương vị của cỏ cây. 
        Đừng ngần ngại nhờ bác tài dừng chân một chút, để lưu lại tấm hình giữa đại ngàn bao 
        la trước khi bước vào hành trình đi bộ`},
      { time: "8:30 AM", description: "Chạm bước vào 'Khu rừng' – Nơi thiên nhiên chữa lành tất cả" },
      { description: `Bắt đầu những bước chân đầu tiên tại điểm xuất phát! Bạn sẽ cảm thấy mình 
         lạc vào những thảm rêu xanh mướt ôm trọn lấy từng thân cây cổ thụ. 
         Đừng lo lắng, các 'hoa tiêu' Porter luôn ở bên cạnh, sẵn sàng chăm sóc 
         bạn từ chai nước đến đôi găng tay. Việc của bạn chỉ là hít căng lồng ngực không
          khí trong lành và tự tin sải bước` },
      { time: "🍃 11:30 AM",  description: `Tới lán Tả Liên Sơn, dùng bữa trưa & Giấc Ngủ "Chill" Giữa Rừng Xanh` },
      { description: `Tới lán dừng chân, một bữa trưa thịnh soạn giữa rừng già đang chờ đón. Sau bữa ăn, 
        hãy dành cho mình 15 phút tĩnh lặng, nhắm mắt lại để lắng nghe tiếng suối reo rì rào và tiếng lá 
        xào xạc. Giấc ngủ ngắn này là món quà 'chill' nhất, giúp bạn hồi sinh mọi giác quan,
         để tâm hồn được thanh lọc hoàn toàn giữa không gian xanh mướt.` },
      { time: "12:30 PM", description: "Chinh phục đỉnh cao Tả Liên Sơn" },
      { description: `Đoạn đường lên đỉnh là phần rực rỡ nhất của chuyến đi. Bạn sẽ bước qua những rừng 
        chè cổ thụ hàng trăm năm tuổi, leo qua những vách đá của Lai Châu. Có những đoạn đường là
         những thân cây đan xen chằng chịt, tạo thành những bậc thang tự nhiên đầy mê hoặc. 
         Mỗi bước chân là một sự khám phá, đưa bạn gần hơn với bầu trời.` },
      { time: "03:30 PM", description: "Chạm đỉnh Tả Liên Sơn (2.996m)" },
      { description: `Chúc mừng bạn! Đứng trên đỉnh cao, thu vào tầm mắt là biển mây bồng bềnh và 
        những dãy núi trùng điệp như PusiLung hay Bạch Mộc Lương Tử. Hãy để làn gió đỉnh núi thổi bay 
        những mệt nhọc, và đừng quên lưu lại những bức hình rạng rỡ nhất của tuổi trẻ trước khi nắng 
        hoàng hôn nhuộm vàng cả không gian` },
      { time: "🏕️ 6:30 PM", description: `Ẩm Thực Tây Bắc và Đêm "Detox Kỹ Thuật Số` },
      { description: `Khi bóng tối buông xuống, lán trại trở nên ấm cúng lạ thường với ánh lửa bập bùng.
         Không sóng điện thoại, không thông báo công việc, chỉ có bạn cùng những câu chuyện đời thường bên 
         mâm cơm đặc sản: gà đen nướng thơm lừng, thịt lợn bản gác bếp. Trong cái se lạnh của núi rừng,
          nằm trong chăn ấm, bạn sẽ thấy quý trọng hơn những giây phút kết nối thật sự với chính mình
           và những người bạn đồng hành.` },
    ],
  },
  {
    day: "Chủ Nhật - Chinh Phục & Trở Về",
    activities: [
      { time: "6:00 AM", description: `Wake up. Đón bình minh tại đỉnh Tả Liên Sơn` },
      { description: `Đây là khoảnh khắc vàng để bạn đứng giữa những cột nắng sớm của rừng thưa. 
        Hãy tận hưởng trọn vẹn và chụp những bức ảnh đẹp nhất để lưu giữ kỷ niệm khó quên này, 
        dù đây là lần đầu hay lần cuối bạn đến với Tả Liên Sơn.` },
      { time: "8:00 AM", description: `Từ lán bắt đầu xuống núi` },
      { description: `Đảm bảo bạn đã dùng đủ năng lượng và kiểm tra kỹ lưỡng, không bỏ sót bất kỳ vật dụng nào
         (đặc biệt là điện thoại, sạc dự phòng). Đảm bảo an toàn là ưu tiên số một. Vui lòng thắt chặt dây giày để
          tránh trượt ngã. Nếu cảm thấy bất kỳ cơn đau hay chấn thương nào ở chân, hãy thông báo ngay lập tức 
         cho hướng dẫn viên/porter để được hỗ trợ kịp thời.`},
      { time: "11:00 AM", description: `Về đến chân núi, dùng bữa trưa.` },
      { description: `Sau những bước chân cuối cùng ra khỏi tán rừng cổ tích, một bữa cơm nóng hổi,
         giản dị nhưng đậm đà vị núi rừng đã sẵn sàng để đón bạn trở về. Đây là lúc cả đoàn cùng ngồi lại,
          nhìn vào những vết lấm lem trên giày nhưng ánh mắt ai cũng lấp lánh niềm vui chiến thắng.
           Một chút 'vị quê' lúc này sẽ giúp bạn thấy ấm lòng và hồi sức nhanh chóng`},
      { time: "12:00 PM", description: "Tạm biệt Tả Liên – Hành trình về với phố núi Sapa" },
      { description: `Tạm biệt những thân cây cổ thụ rêu phong, tạm biệt những đỉnh núi mây mờ che phủ.
         Chúng ta lên xe trở về Sapa. Qua ô cửa kính, hãy một lần nữa ngắm nhìn những thửa ruộng bậc thang
          hay những nếp nhà bản địa lướt qua, để ký ức về Tả Liên được gói ghém thật kỹ trong tim trước 
          khi trở về với nhịp sống hiện đại`},
      { time: "02:20 PM", description: "Tắm lá thuốc người dao tại Sapa" },
      { description: `Đây chính là món quà tinh tế dành tặng riêng cho sự nỗ lực của bạn. Hãy để làn nước 
        khoáng nóng tự nhiên vỗ về những nhóm cơ đã mệt mỏi, xua tan đi cảm giác đau nhức. Trong làn khói 
        hơi nước mờ ảo, bạn sẽ cảm nhận được nguồn năng lượng mới đang len lỏi vào từng tế bào. Một trải 
        nghiệm 'detox' cơ thể hoàn hảo để bạn trở về trong trạng thái rạng rỡ nhất.` },
      { time: "04:30 PM", description: "Lên xe về Hà Nội – Gói trọn yêu thương trong hành lý" },
      { description: `Trước khi lên xe, mình sẽ cùng bạn kiểm tra lại hành lý một lần cuối nhé. 
        Đảm bảo rằng không có chiếc máy ảnh hay món đồ kỷ niệm nào bị bỏ quên. Chuyến xe giường nằm êm ái 
        sẽ là nơi bạn ngả lưng nghỉ ngơi, thả mình vào những bản nhạc nhẹ nhàng và xem lại những thước phim 
        tuyệt đẹp mà chúng ta vừa cùng nhau tạo nên.` },
      { time: "10:30 PM", description: "Về đến Hà Nội – Khép lại một hành trình rực rỡ" }
    ],
  },
];

const TaLienSonSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>Tả Liên Sơn – Hành trình Xuyên Khu Rừng Cổ Tích</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Tả Liên Sơn – ngọn núi cao 2.996 mét tại Lai Châu, không chỉ là một đỉnh cao để thử thách sức bền, mà còn là “Cánh cổng vào Khu Rừng Cổ Tích” của Tây Bắc. 
          Hành trình này đưa bạn lạc bước vào một thế giới nguyên sinh huyền bí, 
          nơi những cây cổ thụ trăm năm tuổi được phủ kín bởi rêu phong và địa y, tạo nên một không gian ma mị, 
          lãng mạn mà bạn khó lòng tìm thấy ở nơi nào khác.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Gốc cổ thụ rừng Tả Liên Sơn
        </p>
        <img src={TaLienSon} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default TaLienSonSchedule;